import * as React from "react";

import { LoaderContext } from "./Context/LoaderContext";
import { ConnectedUserContext } from "./Context/ConnectedUserContext";
import { ToastContext } from "./Context/ToastContext";

const ContextWrapper = ({ children }) => {
  return (
    <LoaderContext>
      <ToastContext>
        <ConnectedUserContext>{children}</ConnectedUserContext>
      </ToastContext>
    </LoaderContext>
  );
};

export default ContextWrapper;
